export default __webpack_public_path__ + "57dd74cbaa93c05c846d4e160ab5262c.png";